import { Loading } from 'element-ui';
import { intersection } from 'lodash';
import { getAuthHeaders } from '@/utils/authentication_headers';
import { showErrorMessage } from '@/ui/message';
import store from '@/store/index';

// const customChecks = {
//   master: currentUser => (
//     currentUser.master && currentUser.master.toString() === 'true'
//   ),
//   notMaster: currentUser => (
//     !currentUser.master || currentUser.master.toString() === 'false'
//   ),
//   admin: currentUser => (
//     currentUser.admin && currentUser.admin.toString() === 'true'
//   ),
//   notAdmin: currentUser => (
//     !currentUser.admin || currentUser.admin.toString() === 'false'
//   ),
//   manager: currentUser => (
//     includes(currentUser.permissions, 'manager')
//   ),
//   officeAdmin: currentUser => (
//     includes(currentUser.permissions, 'officeAdmin')
//   ),
//   employee: currentUser => (
//     includes(currentUser.permissions, 'employee')
//   ),
// };

// const checkPermission = (currentUser, permission) => {
  // if (has(customChecks, permission)) {
  //   return customChecks[permission](currentUser);
  // } else if (permission.indexOf('') === 0) {
  //   return includes(currentUser.permissions, permission.toLowerCase());
  // }
//   return false;
// };
export const fetchCurrentUser = (to, from, next) => {
  const loader = Loading.service({ fullscreen: true });

  store.dispatch('entities/users/getCurrentUser')
    .then((response) => {
      if (!response.status) {
        showErrorMessage(response.error);
        next({
          name: 'home',
          query: { redirect: to.fullPath },
        });
      } else {
        next();
      }
      loader.close();
    });
};

export const Auth = {
  authenticated(to, from, next) {
    const currentUserPresent = store.getters['entities/users/currentUser'] instanceof Object;
    const authToken = getAuthHeaders();
    if (!currentUserPresent && !!authToken.uid) {
      fetchCurrentUser(to, from, next);
      return true;
    }
    return currentUserPresent;
  },

  authorized(permission = false) {
    const currentUser = store.getters['entities/users/currentUser'];

    let permissions = [];
    if (!permission) return true;

    if (typeof (permission) === 'boolean') {
      return permission;
    } else if (permission instanceof Array) {
      permissions = permission;
    } else {
      permissions = [permission];
    }
    const results = intersection(currentUser.permissions, permissions);
    return (results.length > 0);
    // return every(permissions, perm => checkPermission(currentUser, perm));
  },

};

export const withAuth = permissions => (to, from, next) => {
  if (!Auth.authenticated(to, from, next)) {
    next({
      name: 'home',
      query: { redirect: to.fullPath },
    });
  } else if (!Auth.authorized(permissions)) {
    next({ name: 'notAuthorized' });
  } else {
    next();
  }
};

export const redirectOnAuthenticated = (to, from, next) => {
  if (store.getters['entities/users/currentUser'] && to.name === 'home') {
    next({ name: 'dashboard' });
  } else {
    next();
  }
};

export const validateToken = (to, from, next) => {
  const loader = Loading.service({ fullscreen: true });

  store.dispatch('entities/users/validateToken')
    .then((response) => {
      if (!response.status && to.meta && to.meta.showInvalidTokenError) {
        showErrorMessage(response.error);
      }

      loader.close();

      next();
    });
};



// WEBPACK FOOTER //
// ./src/utils/access_control.js